<!-- mainTen -->
<div class="mainTen" *ngIf="showMainTen">
    <div class="contain">
        <h2 class="mainTit" data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">
            국내 유일 <span>'더조각 플러스 시스템'</span> <i></i>적용시 성공할 수 밖에 없는 <i></i>10가지 이유
        </h2>
        <dl data-aos="fade-down" data-aos-delay="300" data-aos-duration="800">
            <dt>1</dt>
            <dd>
                <h2>제품만 공급하는 것이 아닌 <i></i>
                    돈버는 시스템 제공</h2>
                <p>초격차 매출증대 교육, 실습, 보수교육, <i></i>
                    보물자료, 돈버는 마케팅 홍보 등등..</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="400" data-aos-duration="800">
            <dt>2</dt>
            <dd>
                <h2>체계적인 단계적 <i></i>
                    디플로마 및 실전교육</h2>
                <p>스페셜 테라피스트 입문 중급 고급, <i></i>
                    디렉터, 마스터 디렉터</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="500" data-aos-duration="800">
            <dt>3</dt>
            <dd>
                <h2>매출증대 VOD 강의 지속 <i></i>
                    업데이트 제공</h2>
                <p>성공마인드, 마케팅, 세일즈, 경영기초 등..</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="600" data-aos-duration="800">
            <dt>4</dt>
            <dd>
                <h2>매출증대 상담 메뉴얼 제공</h2>
                <p>부위별 상담 메뉴얼 VOD 및 <i></i>
                    메뉴얼 차트 제공</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="700" data-aos-duration="800">
            <dt>5</dt>
            <dd>
                <h2>매출증대 홍보물 디자인 제공</h2>
                <p>부위별 고객 홍보용 디자인 제공</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="800" data-aos-duration="800">
            <dt>6</dt>
            <dd>
                <h2>실전 관리 메뉴얼 제공</h2>
                <p>기기조작법, 부위별 관리 메뉴얼북</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="900" data-aos-duration="800">
            <dt>7</dt>
            <dd>
                <h2>서로 돕고 나누어 <i></i>
                    동반성장 하는 문화</h2>
                <p>성공사례 실시간 공유 및 아낌없는 <i></i>
                    노하우 강의</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="1000" data-aos-duration="800">
            <dt>8</dt>
            <dd>
                <h2>보물 자료방 카페운영</h2>
                <p>국내 최고의 전문가들이 모여 <i></i>
                    최고급 보물자료 공유</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="1100" data-aos-duration="800">
            <dt>9</dt>
            <dd>
                <h2>전문가 소통 단톡방 운영</h2>
                <p>좋은 소식과 정보 실시간 소통 및 교류</p>
            </dd>
        </dl>
        <dl data-aos="fade-down" data-aos-delay="1200" data-aos-duration="800">
            <dt>10</dt>
            <dd>
                <h2>매출증대 시스템 + <i></i>
                    혁신적인 제품</h2>
                <p>성장을 위한 트랜디한 정보와 <i></i>
                    제품 지속 출시</p>
            </dd>
        </dl>
    </div>
</div>
<!-- //mainTen -->

<!-- mainDirector -->
<div class="mainDirector">
    <div class="contain">
        <h2 class="mainTit" data-aos="fade-down" data-aos-delay="200" data-aos-duration="800">
            <p>The jogak Plus System</p>
            뷰티샵 매출증대 를 위해 <i></i>7가지가 준비되어 있어야 합니다
        </h2>
        <ul>
            <li data-aos="fade-down" data-aos-delay="400" data-aos-duration="800"><iframe class="elementor-video" frameborder="0" allowfullscreen="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" title="부수입 월천 1300만원 추가 매출? 이거 모르면 폐업 (네일, 피부, 반영구, 미용실, 왁싱, 속눈썹, 토탈뷰티, 1인샵 창업, 예비창업)" width="640" height="360" src="https://www.youtube.com/embed/s8YkIAKtZ0M?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fthejogak.com&amp;widgetid=3" id="widget4"></iframe></li>
            <li data-aos="fade-down" data-aos-delay="600" data-aos-duration="800"><iframe class="elementor-video" frameborder="0" allowfullscreen="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" title="뷰티샵 매출 2주만에 월천 1000만원 돌파? 모르면 손해보는 돈버는 방법 (1인샵, 피부샵, 네일, 반영구, 미용실, 왁싱, 속눈썹, 토탈뷰티, 창업, 예비창업, 순수입 )" width="640" height="360" src="https://www.youtube.com/embed/7L-NjI2vGXk?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fthejogak.com&amp;widgetid=1" id="widget2"></iframe></li>
            <li data-aos="fade-down" data-aos-delay="800" data-aos-duration="800"><iframe class="elementor-video" frameborder="0" allowfullscreen="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" title="1인샵 망하지 않는 방법 / 뷰티샵 홍보 마케팅 광고비 없이 최대매출 하는 비밀 (재방율80%넘는 이유 ) 브랜딩 추가매출 아이템 매출공개 돈버는 방법" width="640" height="360" src="https://www.youtube.com/embed/Mf75EWXGU8Y?controls=1&amp;rel=0&amp;playsinline=0&amp;modestbranding=0&amp;autoplay=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fthejogak.com&amp;widgetid=5" id="widget6"></iframe></li>
        </ul>
    </div>
</div>
<!-- //mainDirector -->